import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import useHttpHook from "../../Hooks/HttpHook";
import { DeleteOrder } from "../../utils/ApiConstant";
import { dateFormatter } from "../../utils/Helper";
import { OrderLanguage } from "../../utils/Languages";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import MainPagination from "../Common/MainPagination";
import ModalWrapper from "../Common/Portals/ModalWrapper";
import { toast } from "react-toastify";
import { showErrorToast } from "../../utils/notify";

const MyOrderList = ({ orderList, getOrders }) => {
  const [loading, sendRequest, error] = useHttpHook();
  const { userDetails } = useSelector((state) => state.user);
  const [itemIndex, setItemIndex] = useState({
    index: null,
    id: null,
  });
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const location = useLocation();
  const items = orderList?.data?.itemsList || [];

  const handleDeleteOrder = async () => {
    try {
      const res = await sendRequest(`${DeleteOrder}/${itemIndex.id}`, {
        method: "delete",
      });

      if (res?.status === 1) {
        getOrders();
        setIsDeleteModal(false);
      }
    } catch (deleteError) {
      console.log(deleteError);
    }
  };

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      <div className="event-orders-table-wrap">
        {orderList !== null ? (
          items.length > 0 ? (
            <MainPagination
              getEventsMethod={getOrders}
              MainData={orderList}
              PaginationType="paginate"
            >
              <div className="event-orders-table-card">
                <table className="event-orders-table" aria-label="My orders">
                  <thead>
                    <tr>
                      <th scope="col">{OrderLanguage.Columns.eventname}</th>
                      <th scope="col">{OrderLanguage.Columns.registerdName}</th>
                      <th scope="col">{OrderLanguage.Columns.tickets}</th>
                      <th scope="col">{OrderLanguage.Columns.price}</th>
                      <th scope="col">{OrderLanguage.Columns.dateOrder}</th>
                      <th scope="col">Payment Type</th>
                      <th scope="col">{OrderLanguage.Columns.actions}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((order, index) => (
                      <tr key={order._id || index} className="event-orders-row">
                        <td>{order.event?.title}</td>
                        <td>
                          {order.billingDetails.firstName}{" "}
                          {order.billingDetails.lastName}
                        </td>
                        <td>{order.tickets.length}</td>
                        <td className="event-orders-cell-price">
                          USD {parseFloat(order.total).toFixed(2)}
                        </td>
                        <td>{dateFormatter(order.createdAt)}</td>
                        <td>
                          {order?.paymentType === "emi"
                            ? "Split"
                            : order?.paymentType?.toUpperCase()}
                        </td>
                        <td className="event-orders-cell-actions">
                          <Link
                            to={`/myOrder/${order._id}?redirectUrl=${location.pathname}`}
                            className="event-orders-action-btn"
                            aria-label={`View order details for ${order.event?.title}`}
                          >
                            View
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </MainPagination>
          ) : (
            <div className="event-orders-table-card event-orders-table-card--empty">
              <div className="event-orders-empty">No orders found</div>
            </div>
          )
        ) : null}

        {isDeleteModal && (
          <ModalWrapper
            title={OrderLanguage.DeleteOrder.title}
            clickHandler={handleDeleteOrder}
            CloseModalHandler={() => setIsDeleteModal(false)}
          >
            <span>{OrderLanguage.DeleteOrder.message}</span>
          </ModalWrapper>
        )}
      </div>
    </MainComponentWrapper>
  );
};

export default MyOrderList;
